<script>
  import { t } from '../i18n/index.js';
  import { uploadProgress, uploadStatus } from '../stores/screen.js';

  // Use stores if no props provided
  let { progress = null, statusText = null } = $props();

  let displayProgress = $derived(progress ?? $uploadProgress);
  let displayStatus = $derived(statusText ?? ($uploadStatus || t('upload.sending')));
</script>

<div class="screen flex flex-col h-full items-center justify-center p-8">
  <div class="w-full max-w-xs">
    <div class="mb-6 text-center">
      <div class="scan-line-container">
        <div class="scan-line-doc">
          <div class="scan-line"></div>
        </div>
      </div>
    </div>
    <p class="text-center text-gray-300 mb-4 text-lg font-medium">
      {displayStatus}
    </p>
    <div class="w-full bg-gray-700 rounded-full h-2">
      <div
        class="bg-blue-500 h-2 rounded-full transition-all duration-300"
        style="width: {displayProgress}%"
      ></div>
    </div>
  </div>
</div>

<style>
  .screen {
    display: flex;
  }

  .scan-line-container {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }

  .scan-line-doc {
    width: 60px;
    height: 76px;
    margin: 0 auto;
    border: 2px solid rgba(59, 130, 246, 0.6);
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }

  .scan-line {
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #3b82f6, transparent);
    animation: scanDown 1.5s ease-in-out infinite;
  }

  @keyframes scanDown {
    0% { top: 0; }
    50% { top: 100%; }
    100% { top: 0; }
  }
</style>
